import React from 'react';

// Importing icons to match the card style
import WarningIcon from '@material-ui/icons/Warning';
import LocalDrinkIcon from '@material-ui/icons/LocalDrink';
import DomainIcon from '@material-ui/icons/Domain';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// --- Data Constants ---

const SUMMARY_METRICS = [
    { label: 'Demand at Risk', value: '0.6M cases', delta: 'across constraints', tone: 'blue', icon: <WarningIcon />, deltaTone: 'bad' },
    { label: 'Packaging Risk', value: '₹7 Cr', delta: '750ml glass', tone: 'purple', icon: <LocalDrinkIcon />, deltaTone: 'bad' },
    { label: 'Capacity Risk', value: '₹12 Cr', delta: 'South bottling', tone: 'orange', icon: <DomainIcon />, deltaTone: 'bad' },
    { label: 'Mitigated Value', value: '₹16 Cr', delta: 'actions identified', tone: 'green', icon: <CheckCircleIcon />, deltaTone: 'good' },
];

const HEATMAP_DATA = [
    { label: 'Demand', cells: ['green', 'amber', 'red', 'amber', 'green'] },
    { label: 'Bulk', cells: ['amber', 'red', 'amber', 'green', 'green'] },
    { label: 'Glass', cells: ['red', 'amber', 'green', 'green', 'amber'] },
    { label: 'Bottling', cells: ['amber', 'green', 'green', 'amber', 'red'] },
    { label: 'Logistics', cells: ['green', 'green', 'amber', 'red', 'amber'] },
];

const TOP_RISKS = [
    { risk: '750ml glass', atRisk: '₹7 Cr', mitigation: 'Alternate source' },
    { risk: 'South capacity', atRisk: '₹12 Cr', mitigation: 'Shift volume' },
    { risk: 'Premium bulk', atRisk: '₹6 Cr', mitigation: 'Prioritize SKUs' },
    { risk: 'East freight', atRisk: '₹3 Cr', mitigation: 'Reroute' },
    { risk: 'Demand spike', atRisk: '₹8 Cr', mitigation: 'Prebuild' },
];

export class Risk extends React.Component {
    render() {
        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>Supply Chain Risk & Resilience</h1>
                        <p>Quantify risks to demand fulfilment across bulk, packaging, bottling and logistics before they hit service.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the card style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row">
                    {/* Left Panel: Risk Heatmap */}
                    <div className="cc-panel">
                        <h2>Risk Heatmap — Demand × Supply × Site</h2>
                        
                        <div className="cc-heatmap-container">
                            {HEATMAP_DATA.map((row) => (
                                <div className="cc-heatmap-row" key={row.label}>
                                    <div className="cc-heatmap-label">{row.label}</div>
                                    <div className="cc-heatmap-cells">
                                        {row.cells.map((color, index) => (
                                            <div 
                                                key={index} 
                                                className={`cc-heatmap-cell heat-${color}`}
                                            ></div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        <div className="cc-heatmap-footer">
                            Low ← likelihood / impact → High
                        </div>
                    </div>

                    {/* Right Panel: Top Risks & Mitigation */}
                    <div className="cc-panel cc-panel-table">
                        <h2>Top Risks & Mitigation</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Risk</th>
                                    <th>₹ at Risk</th>
                                    <th>Mitigation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {TOP_RISKS.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.risk}</td>
                                        <td>{row.atRisk}</td>
                                        <td>{row.mitigation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Risk;